import { combineReducers } from 'redux';

  export const FETCHING_CONSULTA_ACESSO_PERMISSOES = 'FETCHING_CONSULTA_ACESSO_PERMISSOES';
  export const FETCH_CONSULTA_ACESSO_PERMISSOES_SUCCESS = 'FETCH_CONSULTA_ACESSO_PERMISSOES_SUCCESS';
  export const FETCH_CONSULTA_ACESSO_PERMISSOES_ERROR = 'FETCH_CONSULTA_ACESSO_PERMISSOES_ERROR';

  export const CONSULTA_ACESSO_SET_MODE = 'CONSULTA_ACESSO_SET_MODE';
  export const CONSULTA_ACESSO_SET_SEARCH_TERM = 'CONSULTA_ACESSO_SET_SEARCH_TERM';
  export const FETCHING_CONSULTA_ACESSO = 'FETCHING_CONSULTA_ACESSO';
  export const FETCH_CONSULTA_ACESSO_SUCCESS = 'FETCH_CONSULTA_ACESSO_SUCCESS';
  export const FETCH_CONSULTA_ACESSO_ERROR = 'FETCH_CONSULTA_ACESSO_ERROR';
  export const CONSULTA_ACESSO_SELECT_RESULT = 'CONSULTA_ACESSO_SELECT_RESULT';
  export const CONSULTA_ACESSO_CLEAR = 'CONSULTA_ACESSO_CLEAR';

  export const FETCHING_CONSULTA_ACESSO_FAVORITOS = 'FETCHING_CONSULTA_ACESSO_FAVORITOS';
  export const FETCH_CONSULTA_ACESSO_FAVORITOS_SUCCESS = 'FETCH_CONSULTA_ACESSO_FAVORITOS_SUCCESS';
  export const FETCH_CONSULTA_ACESSO_FAVORITOS_ERROR = 'FETCH_CONSULTA_ACESSO_FAVORITOS_ERROR';
  export const CONSULTA_ACESSO_ADD_FAVORITO = 'CONSULTA_ACESSO_ADD_FAVORITO';
  export const CONSULTA_ACESSO_REMOVE_FAVORITO = 'CONSULTA_ACESSO_REMOVE_FAVORITO';
  export const CONSULTA_ACESSO_REMOVE_TODOS_FAVORITOS = 'CONSULTA_ACESSO_REMOVE_TODOS_FAVORITOS';

  export const FETCH_CONSULTA_ACESSO_DEPARTAMENTOS_SUCCESS = 'FETCH_CONSULTA_ACESSO_DEPARTAMENTOS_SUCCESS';
  export const FETCH_CONSULTA_ACESSO_GRUPOS_SUCCESS = 'FETCH_CONSULTA_ACESSO_GRUPOS_SUCCESS';
  export const CONSULTA_ACESSO_SET_FILTRO_DEPARTAMENTO = 'CONSULTA_ACESSO_SET_FILTRO_DEPARTAMENTO';
  export const CONSULTA_ACESSO_SET_FILTRO_GRUPO = 'CONSULTA_ACESSO_SET_FILTRO_GRUPO';
  export const CONSULTA_ACESSO_SET_MODO_BUSCA = 'CONSULTA_ACESSO_SET_MODO_BUSCA';
  export const CONSULTA_ACESSO_SET_INCLUIR_INATIVOS = 'CONSULTA_ACESSO_SET_INCLUIR_INATIVOS';

  const nivel = (state = null, action) => {
    switch (action.type) {
      case FETCH_CONSULTA_ACESSO_PERMISSOES_SUCCESS:
        return action.payload.nivel;
      default:
        return state;
    }
  };

  const podeVerClientes = (state = false, action) => {
    switch (action.type) {
      case FETCH_CONSULTA_ACESSO_PERMISSOES_SUCCESS:
        return action.payload.pode_ver_clientes;
      default:
        return state;
    }
  };

  const podeVerSenhaClienteAmbiente = (state = false, action) => {
    switch (action.type) {
      case FETCH_CONSULTA_ACESSO_PERMISSOES_SUCCESS:
        return action.payload.pode_ver_senha_cliente_ambiente || false;
      default:
        return state;
    }
  };

  const apenasClientes = (state = false, action) => {
    switch (action.type) {
      case FETCH_CONSULTA_ACESSO_PERMISSOES_SUCCESS:
        return action.payload.apenas_clientes || false;
      default:
        return state;
    }
  };

  // Char 695 (Acesso Senha Aprovacao) — flag vem do servidor, autoritativo.
  const podeVerSenhaAprovacao = (state = false, action) => {
    switch (action.type) {
      case FETCH_CONSULTA_ACESSO_PERMISSOES_SUCCESS:
        return action.payload.pode_ver_senha_aprovacao || false;
      default:
        return state;
    }
  };

  const loadingPermissoes = (state = false, action) => {
    switch (action.type) {
      case FETCHING_CONSULTA_ACESSO_PERMISSOES:
        return true;
      case FETCH_CONSULTA_ACESSO_PERMISSOES_SUCCESS:
      case FETCH_CONSULTA_ACESSO_PERMISSOES_ERROR:
        return false;
      default:
        return state;
    }
  };

  const isUser = (state = true, action) => {
    switch (action.type) {
      case CONSULTA_ACESSO_SET_MODE:
        return action.payload;
      case CONSULTA_ACESSO_CLEAR:
        return true;
      default:
        return state;
    }
  };

  const searchTerm = (state = '', action) => {
    switch (action.type) {
      case CONSULTA_ACESSO_SET_SEARCH_TERM:
        return action.payload;
      case CONSULTA_ACESSO_SET_MODE:
      case CONSULTA_ACESSO_CLEAR:
        return '';
      default:
        return state;
    }
  };

  const results = (state = [], action) => {
    switch (action.type) {
      case FETCH_CONSULTA_ACESSO_SUCCESS:
        return action.payload;
      case CONSULTA_ACESSO_SET_MODE:
      case CONSULTA_ACESSO_CLEAR:
        return [];
      default:
        return state;
    }
  };

  const selectedResult = (state = null, action) => {
    switch (action.type) {
      case CONSULTA_ACESSO_SELECT_RESULT:
        return action.payload;
      case FETCH_CONSULTA_ACESSO_SUCCESS:
        return action.payload.length === 1 ? action.payload[0] : null;
      case CONSULTA_ACESSO_SET_MODE:
      case CONSULTA_ACESSO_CLEAR:
        return null;
      default:
        return state;
    }
  };

  const loading = (state = false, action) => {
    switch (action.type) {
      case FETCHING_CONSULTA_ACESSO:
        return true;
      case FETCH_CONSULTA_ACESSO_SUCCESS:
      case FETCH_CONSULTA_ACESSO_ERROR:
        return false;
      default:
        return state;
    }
  };

  const error = (state = null, action) => {
    switch (action.type) {
      case FETCH_CONSULTA_ACESSO_ERROR:
        return action.payload;
      case FETCHING_CONSULTA_ACESSO:
      case FETCH_CONSULTA_ACESSO_SUCCESS:
      case CONSULTA_ACESSO_SET_MODE:
      case CONSULTA_ACESSO_CLEAR:
        return null;
      default:
        return state;
    }
  };

  const favoritos = (state = [], action) => {
    switch (action.type) {
      case FETCH_CONSULTA_ACESSO_FAVORITOS_SUCCESS:
        return action.payload;
      case CONSULTA_ACESSO_REMOVE_FAVORITO:
        return state.filter(f => f.identificador !== action.payload);
      case CONSULTA_ACESSO_REMOVE_TODOS_FAVORITOS:
        return [];
      default:
        return state;
    }
  };

  const favoritosIds = (state = [], action) => {
    switch (action.type) {
      case FETCH_CONSULTA_ACESSO_FAVORITOS_SUCCESS:
        return action.payload.map(f => f.identificador);
      case CONSULTA_ACESSO_ADD_FAVORITO:
        return state.includes(action.payload) ? state : [...state, action.payload];
      case CONSULTA_ACESSO_REMOVE_FAVORITO:
        return state.filter(id => id !== action.payload);
      case CONSULTA_ACESSO_REMOVE_TODOS_FAVORITOS:
        return [];
      default:
        return state;
    }
  };

  const loadingFavoritos = (state = false, action) => {
    switch (action.type) {
      case FETCHING_CONSULTA_ACESSO_FAVORITOS:
        return true;
      case FETCH_CONSULTA_ACESSO_FAVORITOS_SUCCESS:
      case FETCH_CONSULTA_ACESSO_FAVORITOS_ERROR:
        return false;
      default:
        return state;
    }
  };

  const departamentos = (state = [], action) => {
    switch (action.type) {
      case FETCH_CONSULTA_ACESSO_DEPARTAMENTOS_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  };

  const grupos = (state = [], action) => {
    switch (action.type) {
      case FETCH_CONSULTA_ACESSO_GRUPOS_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  };

  const modoBusca = (state = 'departamento', action) => {
    switch (action.type) {
      case CONSULTA_ACESSO_SET_MODO_BUSCA:
        return action.payload;
      case CONSULTA_ACESSO_SET_MODE:
      case CONSULTA_ACESSO_CLEAR:
        return 'departamento';
      default:
        return state;
    }
  };

  const filtroDepartamento = (state = null, action) => {
    switch (action.type) {
      case CONSULTA_ACESSO_SET_FILTRO_DEPARTAMENTO:
        return action.payload;
      case CONSULTA_ACESSO_SET_MODO_BUSCA:
      case CONSULTA_ACESSO_SET_MODE:
      case CONSULTA_ACESSO_CLEAR:
        return null;
      default:
        return state;
    }
  };

  const filtroGrupo = (state = null, action) => {
    switch (action.type) {
      case CONSULTA_ACESSO_SET_FILTRO_GRUPO:
        return action.payload;
      case CONSULTA_ACESSO_SET_MODO_BUSCA:
      case CONSULTA_ACESSO_SET_MODE:
      case CONSULTA_ACESSO_CLEAR:
        return null;
      default:
        return state;
    }
  };

  const incluirInativos = (state = false, action) => {
    switch (action.type) {
      case CONSULTA_ACESSO_SET_INCLUIR_INATIVOS:
        return action.payload;
      case CONSULTA_ACESSO_SET_MODE:
      case CONSULTA_ACESSO_CLEAR:
        return false;
      default:
        return state;
    }
  };

  export default combineReducers({
    nivel,
    podeVerClientes,
    podeVerSenhaClienteAmbiente,
    podeVerSenhaAprovacao,
    apenasClientes,
    loadingPermissoes,
    isUser,
    searchTerm,
    results,
    selectedResult,
    loading,
    error,
    favoritos,
    favoritosIds,
    loadingFavoritos,
    departamentos,
    grupos,
    modoBusca,
    filtroDepartamento,
    filtroGrupo,
    incluirInativos,
  });